<template>
    <section>
        <div :class="{ 'chatOpen': visible }" class="chat-comunity">
            <template v-if="selectedMesage === null">
                <div class="chat-header">
                    <svg @click="toggleVisibilityAdmin()" xmlns="http://www.w3.org/2000/svg" width="7" height="15"
                        viewBox="0 0 7 15" fill="none">
                        <path d="M6 0.5L1 7.5L6 14.5" stroke="#464D5B" />
                    </svg>

                    <p>Bandeja de Administradores</p>
                </div>

                <hr>
                <!-- new readed -->
                <div class="list-container">
                    <!-- Asi se ve un chat nuevo en la bandeja-->
                    <div v-for="(item, index) in rooms" :key="index" @click="selectedMesage = item, updateChatMessage(item.roomId), item.readed = true, item.new = false" class="list-msg" :class="{ 'readed':  !item.readed, 'new':  item.new }">
                        <div class="list-msgHeader">
                            <img v-if="item.user.image === null" src="../../assets/default/icon-user.png" alt="">
                            <img v-else :src="url+`/user-img/`+item.user.image" alt="">
                            <p>{{ item.user.name + ' ' + item.user.lastname}}</p>

                            <span>{{ item.lastMessage.createdAt | formatDate }}</span>
                            <span>{{ item.lastMessage.createdAt | formatHour }}</span>
                        </div>
                        <p v-html="item.lastMessage.message"></p>

                        <button class="markAsRead">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17"
                                fill="none">
                                <mask id="mask0_3223_7674" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0"
                                    y="0" width="18" height="17">
                                    <rect x="0.5" width="17" height="17" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_3223_7674)">
                                    <path
                                        d="M7.81 12.4102L13.8025 6.41766L12.6125 5.22766L7.81 10.0302L5.3875 7.60766L4.1975 8.79766L7.81 12.4102ZM9 17.0002C7.82417 17.0002 6.71917 16.777 5.685 16.3308C4.65083 15.8845 3.75125 15.2789 2.98625 14.5139C2.22125 13.7489 1.61563 12.8493 1.16938 11.8152C0.723125 10.781 0.5 9.67599 0.5 8.50016C0.5 7.32433 0.723125 6.21933 1.16938 5.18516C1.61563 4.15099 2.22125 3.25141 2.98625 2.48641C3.75125 1.72141 4.65083 1.11579 5.685 0.669535C6.71917 0.223285 7.82417 0.000160217 9 0.000160217C10.1758 0.000160217 11.2808 0.223285 12.315 0.669535C13.3492 1.11579 14.2488 1.72141 15.0138 2.48641C15.7788 3.25141 16.3844 4.15099 16.8306 5.18516C17.2769 6.21933 17.5 7.32433 17.5 8.50016C17.5 9.67599 17.2769 10.781 16.8306 11.8152C16.3844 12.8493 15.7788 13.7489 15.0138 14.5139C14.2488 15.2789 13.3492 15.8845 12.315 16.3308C11.2808 16.777 10.1758 17.0002 9 17.0002ZM9 15.3002C10.8983 15.3002 12.5063 14.6414 13.8238 13.3239C15.1413 12.0064 15.8 10.3985 15.8 8.50016C15.8 6.60183 15.1413 4.99391 13.8238 3.67641C12.5063 2.35891 10.8983 1.70016 9 1.70016C7.10167 1.70016 5.49375 2.35891 4.17625 3.67641C2.85875 4.99391 2.2 6.60183 2.2 8.50016C2.2 10.3985 2.85875 12.0064 4.17625 13.3239C5.49375 14.6414 7.10167 15.3002 9 15.3002Z"
                                        fill="#66B546" />
                                </g>
                            </svg>
                        </button>
                    </div>
                    <!-- Si abres la bandeja pero no abres el mensaje se ve asi -->
                  
                </div>
            </template>
            <!-- CHAT -->
            <template v-else>
                <div class="chat-header">
                    <svg @click="toggleVisibilityAdmin(), selectedMesage = null" xmlns="http://www.w3.org/2000/svg" width="7" height="15"
                        viewBox="0 0 7 15" fill="none">
                        <path d="M6 0.5L1 7.5L6 14.5" stroke="#464D5B" />
                    </svg>

                    <p>Chat Administradores</p>
                </div>

                <hr>
                <!-- msg-container admin / self / '' -->
                <div class="chat-container">
                    <div class="msg-container" v-for="(item, index) in chatMessages" :key="index" :class="{'admin': item.user.role !== 'client', 'self': item.userId === identity.id }">
                        <div class="headMsg">
                            <div class="headUser">
                                <img v-if="item.user.image === null" src="../../assets/pfpDefault.png" alt="">
                                <img v-else :src="url+`/user-img/`+item.user.image" alt="">
                                <p>{{ item.user.name + ' ' + item.user.lastname }}</p>
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18"
                                    fill="none">
                                    <path
                                        d="M7.5 0.5C8.47633 0.5 8.9645 1.19721 8.9645 2.59162C8.9645 3.21466 8.90532 3.94154 8.78698 4.77225L8.60947 5.92932C8.5503 6.43368 8.50592 6.7452 8.47633 6.86387L8.38757 7.44241L10.5178 5.75131C11.9083 4.62391 12.9142 4.06021 13.5355 4.06021C14.1568 4.06021 14.5858 4.29756 14.8225 4.77225C14.9408 4.95026 15 5.15794 15 5.39529C15 6.04799 14.6598 6.58203 13.9793 6.99738C13.3284 7.38307 12.4408 7.78359 11.3166 8.19895L9.31953 9L11.8047 9.97906C12.6923 10.3351 13.3432 10.6466 13.7574 10.9136C14.5858 11.3586 15 11.9223 15 12.6047C15 12.8124 14.8964 13.0942 14.6893 13.4503C14.5118 13.7766 14.1272 13.9398 13.5355 13.9398C12.9438 13.9398 11.9379 13.3761 10.5178 12.2487L8.38757 10.5576L8.47633 11.2251C8.47633 11.3735 8.52071 11.6702 8.60947 12.1152L8.87574 13.6728C8.93491 14.2661 8.9645 14.8595 8.9645 15.4529C8.9645 16.0166 8.83136 16.5061 8.56509 16.9215C8.3284 17.3072 7.97337 17.5 7.5 17.5C7.02663 17.5 6.65681 17.3072 6.39053 16.9215C6.15385 16.5061 6.0355 16.0017 6.0355 15.4084C6.0355 14.7853 6.09468 14.0585 6.21302 13.2277L6.39053 12.0707C6.4497 11.5663 6.49408 11.2548 6.52367 11.1361L6.61243 10.5576L4.48225 12.2487C3.09172 13.3761 2.0858 13.9398 1.4645 13.9398C0.843195 13.9398 0.414201 13.7024 0.177515 13.2277C0.0591716 13.0497 0 12.8421 0 12.6047C0 11.952 0.325444 11.4328 0.976331 11.0471C1.6568 10.6318 2.55917 10.2164 3.68343 9.80105L5.68047 9L3.19527 8.02094C2.33728 7.69459 1.6716 7.38307 1.19822 7.08639C0.399408 6.61169 0 6.04799 0 5.39529C0 5.18761 0.0887574 4.92059 0.266272 4.59424C0.473373 4.23822 0.798816 4.06021 1.2426 4.06021C1.71598 4.06021 2.18935 4.20855 2.66272 4.50523C3.13609 4.77225 3.7426 5.18761 4.48225 5.75131L6.61243 7.44241L6.52367 6.77487C6.52367 6.62653 6.47929 6.32984 6.39053 5.88482L6.12426 4.32723C6.06509 3.73386 6.0355 3.14049 6.0355 2.54712C6.0355 1.92408 6.15385 1.43455 6.39053 1.07853C6.65681 0.692845 7.02663 0.5 7.5 0.5Z"
                                        fill="url(#paint0_linear_2967_4960)" />
                                    <defs>
                                        <linearGradient id="paint0_linear_2967_4960" x1="15" y1="9" x2="0" y2="9"
                                            gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#FFE711" />
                                            <stop offset="1" stop-color="#96FF11" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </div>
                            <span>{{ item.createdAt | formatDate }}</span>
                            <span>{{ item.createdAt | formatHour }}</span>
                        </div>
                        <p v-html="item.message"></p>
                    </div>
                </div>
                <div class="input-container">
                    <p>Escribe tu comentario</p>
                    <VueEditor v-model="newMessage" id="description" placeholder="Descripción" class="vue__editor"
                        :editor-toolbar="customToolbar" />
                    <button @click="sendMessage(newMessage)">
                        <p>Enviar</p>
                    </button>
                </div>
            </template>
        </div>

        <div @click="toggleVisibilityAdmin()" v-if="visible" class="backdrop"></div>
    </section>
</template>

<script>
import { VueEditor } from "vue2-editor";
import Notificacion from "@/components/utils/notificacion.vue";
import { mapActions } from "vuex";
import dayjs from "dayjs";
import { url } from "@/global/index"
export default {
    name: 'ChatAdmins',
    components: {
        VueEditor,
        Notificacion
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            customToolbar: [
                [],
            ],
            selectedMesage: null,
            toastType: '',
            toastTitle: '',
            toastSub: '',
            toastState: false,
            regLoading: false,
            process:"",
            newMessage:"",
            url,
        };
    },
    mounted() {
        this.sockets.subscribe('newMessage:Admin', async (data) => {
            await this.getRooms()
        }); 
        this.sockets.subscribe('newMessage', async (data) => {
            await this.updateChatMessage(data.roomId)
        }); 
    },
    async created(){
        this.regLoading = true
        this.process = "Cargando mensajes"
        await this.getIdentity()
        await this.getRooms()
        this.regLoading = false
    },
    computed:{
        identity() {
            return this.$store.getters['admin/getIdentity'];
        },
        rooms() {
            const data = this.$store.getters['chatroomlist/data']
            if(!Array.isArray(data)) return []
            const filtered = []
            for (const item of data) {
                const find = filtered.find(chat => chat.roomId === item.roomId)
                if(!find) filtered.push({
                    ...item,
                    new: true,
                    readed: false,
                })
            }

            return filtered
        },
        chatMessages() {
            const data = this.$store.getters['chatmessagelist/data']
            return data
        },
    },
    methods: {
        ...mapActions("chatroomlist", ["getAllInfoCtl"]),
        ...mapActions("chatmessagelist", ["getAllInfoCml"]),

        toggleVisibilityAdmin() {
            this.$emit('update:visible', !this.visible);
        },
        
        setNoti(toastState, toastType, toastTitle, toastSub) {
           
           this.toastState = toastState
           this.toastType = toastType
           this.toastTitle = toastTitle
           this.toastSub = toastSub
           setTimeout(() => {
               location.reload();
               this.clearToast();
           }, 3000);
       },

       clearToast() {
           this.toastState = false
       },

       async getRooms(){
            await this.getAllInfoCtl("chat-list")
            this.chatRoom
        },

        async updateChatMessage(roomId){
            await this.getAllInfoCml(`message?roomId=${roomId}&take=100`)
            this.chatMessages
        },

        getIdentity: async function () {
            const response = await this.$store.dispatch("admin/getData");
            return response
        },

        sendMessage(newMessage){
            if(!newMessage) return
            if(!this.identity.id || !this.selectedMesage.roomId){
                this.setNoti(true, 'Error', 'Ha ocurrido un error', "Vuelve a intentar de nuevo")
                return
            }
            const data = {
                userId: this.identity.id,
                roomId: this.selectedMesage.roomId,
                message: newMessage,
            }
            this.$socket.emit("sendMessage", data);
            this.$socket.emit("sendMessage:Admin", data);
            this.newMessage = ""
        }

    },
    filters: {
        formatDate(value){
            return dayjs(value).format('DD/MM/YYYY')
        },
        formatHour(value){
            return dayjs(value).format('HH:mm A')
        }
    }
};
</script>

<style scoped>
.backdrop {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 18;
}

.chat-comunity {
    position: fixed;
    z-index: 20;
    top: 0;
    right: -38.541667vw;
    height: 100%;
    width: 38.541667vw;

    display: flex;
    flex-direction: column;
    gap: 1.388889vw;


    padding: 2.083333vw 1.041667vw 1.041667vw 1.041667vw !important;

    border-radius: 2.083333vw 0vw 0vw 2.083333vw;
    background: #FFF;
    box-shadow: -0.486111vw 0vw 1.340278vw 0vw rgba(0, 0, 0, 0.15);
    transition: right 0.3s ease;
}

.chatOpen {
    right: 0 !important;
}

.chat-header {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: .555556vw;
    align-self: stretch;
}

.chat-header svg {
    width: .555556vw;
    height: .972222vw;
    cursor: pointer;
}

.chat-header p {
    width: 100%;
    color: var(--Text, #464D5B);
    text-align: center;
    font-family: Manrope;
    font-size: 1.25vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

hr {
    width: 100%;
    border: 0;
    height: .069444vw;
    background-color: #E3E3E9;
}

.chat-container {
    display: flex;
    padding: 1.041667vw;
    flex-direction: column;
    align-items: center;
    gap: 1.388889vw;
    flex: 1 0 0;
    align-self: stretch;

    border-radius: 2.083333vw;
    border: .069444vw solid var(--background-gray, #E3E3E9);
    background: #FFF;
    overflow-y: auto;
    flex-direction: column-reverse;

}

/* Hide scrollbar for Chrome, Safari and Opera */
.chat-container::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.chat-container {
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
}

.input-container {
    display: flex;
    height: 16.041667vw;
    padding: 1.388889vw 1.041667vw;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    flex-shrink: 0;
    align-self: stretch;

    border-radius: 1.388889vw;
    border: .069444vw solid var(--background-gray, #E3E3E9);
    background: var(--white, #FFF);
}

.input-container p {
    color: var(--Text, #464D5B);
    text-align: center;
    font-family: Manrope;
    font-size: .833333vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    align-self: stretch;
}

.input-container button {
    display: flex;
    padding: .694444vw 1.388889vw;
    justify-content: center;
    align-items: center;
    gap: .694444vw;
    align-self: stretch;
    border-radius: 20.833333vw;
    background: var(--purple, #B359F8);
}

.input-container button p {
    color: #FFF;
    text-align: center;
    font-family: Manrope;
    font-size: 1.041667vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.msg-container {
    display: flex;
    padding: .694444vw;
    flex-direction: column;
    gap: .347222vw;
    align-self: stretch;
}

.msg-container>p {
    color: var(--Text, #464D5B);
    font-family: Manrope;
    font-size: .833333vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.headMsg {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.headUser {
    display: flex;
    align-items: center;
    gap: .694444vw;
    width: 50%;
}

.headUser p {
    font-family: Manrope;
    font-size: .833333vw;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    background: var(--gradient-2, linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.headMsg span {
    color: var(--background-gray, #E3E3E9);
    text-align: center;
    font-family: Manrope;
    font-size: .694444vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.headMsg img {
    border-radius: 6.944444vw;
    width: 2.638889vw;
    height: 2.638889vw;
}

.headMsg svg {
    width: 1.041667vw;
    height: 1.180556vw;
    display: none;
}

.admin.msg-container {
    border-radius: 1.388889vw;
    border: .069444vw solid var(--gradient-2, #4536EF);
}

.self.msg-container {
    border-radius: 1.388889vw;
    background: var(--background-gray, #E3E3E9);
}


/* VueEditorStyles */

.vue__editor {
    width: 100%;
    border-color: #E3E3E9;
    border: .069444vw solid #E3E3E9;
    border-radius: .694444vw;
}

.vue__editor>>>.ql-toolbar.ql-snow {
    padding-top: .277778vw !important;
    padding-bottom: .277778vw !important;
    height: 2.777778vw !important;
    border-color: #DBDBDB;
    display: none;
}

.vue__editor>>>.quillWrapper .ql-snow.ql-toolbar .ql-formats {
    margin-bottom: 0 !important;
}

.vue__editor>>>.ql-toolbar.ql-snow .ql-formats {
    margin-right: 0 !important;
}

.vue__editor>>>.ql-toolbar.ql-snow+.ql-container.ql-snow {
    border-color: #fff;
    border: .069444vw solid #fff;
    border-radius: .694444vw;
}

.vue__editor>>>.ql-editor {
    min-height: unset !important;
    height: 7.361111vw;
    color: #323232 !important;
    font-family: "DM Sans" !important;

    font-size: .833333vw !important;
    line-height: normal !important;
    padding: 1.041667vw !important;

}

.vue__editor>>>.ql-editor.ql-blank::before {
    font-weight: 300 !important;
}


.list-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.388889vw;
    flex: 1 0 0;
    align-self: stretch;

    background: #FFF;
    overflow-y: auto;
    flex-direction: column-reverse;

}

/* Hide scrollbar for Chrome, Safari and Opera */
.list-container::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.list-container {
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
}

.list-msg {
    display: flex;
    padding: 1.041667vw .694444vw;
    flex-direction: column;
    gap: .347222vw;
    align-self: stretch;

    border-radius: 1.388889vw;
    border: .069444vw solid var(--background-gray, #E3E3E9);
    cursor: pointer;
}

.list-msgHeader {
    display: flex;
    flex-direction: row;
    gap: .694444vw;
    align-items: center;
}

.list-msgHeader img {
    border-radius: 6.944444vw;
    width: 2.638889vw;
    height: 2.638889vw;
}

.list-msgHeader p {
    font-family: Manrope;
    font-size: .833333vw;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    background: var(--gradient-2, linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-right: auto;
}

.list-container span {
    color: var(--background-gray, #E3E3E9);
    text-align: center;
    font-family: Manrope;
    font-size: .694444vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.list-msg>p {
    color: var(--Text, #464D5B);
    font-family: Manrope;
    font-size: .833333vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-left: 3.402778vw;
}

.markAsRead {
    width: fit-content;
    margin-left: auto;
}

.markAsRead svg {
    width: 1.180556vw;
    height: 1.180556vw;
    flex-shrink: 0;
    filter: contrast(0);

}

.list-msg.new {
    border-color: #96FF11;
}

.list-msg.readed svg {
    filter: contrast(1);
}
</style>